<app-ace-select bindValue="sustainability_rating_id"
                [id]="elementId"
                [placeholder]="'Please select a Sustainability Rating' | messageTranslate"
                [loading]="loading"
                [items]="ratingOptions"
                [clearable]="clearable"
                [groupBy]="ratingsGroupByFn">
  <ng-template #optionTemplate let-rating="item">
    @if (asRatingOption(rating); as ratingOption) {
      @if (displayTypeNameOnly) {
        <div>
          {{ratingOption.sustainability_rating_type.name}}
        </div>
      } @else {
        @if (searchCriteria?.limit_per_site_and_type === 2 || (ratingOption.latest && (searchCriteria?.limit_per_site_and_type == null || searchCriteria.limit_per_site_and_type > 2))) {
          <div class="fw-bold">
            {{ratingOption.latest ? ('Latest' | messageTranslate) : ('Previous' | messageTranslate)}}
          </div>
        }
        <div class="small">{{ratingOption.period_start_date?.format(DATE_FORMAT)}} - {{ratingOption.period_end_date?.format(DATE_FORMAT)}}</div>
      }
    }
  </ng-template>
  <ng-template #labelTemplate let-rating="item">
    @if (ratingOptions?.length) {
      <span>{{rating.sustainability_rating_type?.name + (displayTypeNameOnly ? '' : ' (' + rating.period_start_date?.format(DATE_FORMAT) + ' - ' + rating.period_end_date?.format(DATE_FORMAT) + ')')}}</span>
    }
  </ng-template>
</app-ace-select>
